import {
    BoxProps,
    Flex,
    Grid,
    GridItem,
    Tag,
    TagLabel,
    Text
} from "@chakra-ui/react";
import { useGamCampaignInfo } from ".";
import { DetailField } from "../../components/detailField/DetailField";
import { DetailFieldListBox } from "../../components/detailFieldListBox/DetailFieldListBox";


export const DetailsSummary = ({ props, variant }: { props?: BoxProps; variant?: string })  => {
    const { gamCampaign } = useGamCampaignInfo();

    return (
        <Flex direction={"column"} {...props}>
            <DetailField label={"Campaign Name:"} value={gamCampaign.name} variant={variant? variant : ""} />
            <Grid
                templateColumns="flex"
                gap={2}
                mb={4}
                alignItems={"flex-start"}
            >
                <GridItem colSpan={3}>
                <Text
                    color={"primary.darker"}
                    fontWeight={"semibold"}
                    fontSize={"sm"}
                    mr={2}
                >
                    Status:
                </Text>
                </GridItem>
                <GridItem colSpan={5}>
                <Tag
                    size={"sm"}
                    bg={gamCampaign.active ? "primary.light" : "inactive"}
                    colorScheme="teal"
                    borderRadius={"full"}
                >
                    <TagLabel>{gamCampaign.active ? "active" : "inactive"}</TagLabel>
                </Tag>
                </GridItem>
            </Grid>
            <DetailField label={"Start Date:"} value={gamCampaign.startDate} variant={variant? variant : ""}/>
            <DetailField
                variant={variant? variant : ""}
                label={"End Date:"}
                value={gamCampaign.endDate ? gamCampaign.endDate : "TBD"}
            />
            {gamCampaign.domains.length > 0 && (
                <DetailFieldListBox
                    variant={variant? variant : ""}
                    label={"Domains:"}
                    value={gamCampaign.domains}
                    useTag={true}
                />
            )}
        </Flex>
    );
}
